import { render } from "./MctChart.vue?vue&type=template&id=5d71128d"
import script from "./MctChart.vue?vue&type=script&lang=js"
export * from "./MctChart.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__